import { useQuery } from '@tanstack/react-query'
import { fetchFilters } from '@services/api/filterAPI'

export const useFetchFilters = (sourceId: string) => {
  return useQuery({
    queryKey: ['filters', { sourceId }],
    queryFn: async () => fetchFilters(sourceId),
    initialData: {},
    enabled: !!sourceId,
    refetchOnWindowFocus: false
  })
}
